import React, {createContext, useContext, useEffect} from 'react';
import PropTypes from 'prop-types';
import {useFormik, FormikProvider} from 'formik';
import {useOldInspectionDetailsContext} from './OldInspectionsDetailsContext';
import {updateShumaStatus} from '../../_common/actions/shumaStatusActions';

type OldInspectionStatusContext = {
  status: {label: string, value: number}
  onChangeStatus: (e: React.ChangeEvent<HTMLInputElement>) => void
}

interface OldInspectionStatusProviderProps {
  children: React.ReactNode;
}

const OldInspectionStatusContext = createContext<OldInspectionStatusContext>({} as OldInspectionStatusContext);

export function useOldInspectionStatusContext() {
  return useContext(OldInspectionStatusContext);
}

export function OldInspectionStatusProvider({children}: OldInspectionStatusProviderProps) {
  //@ts-ignore
  const {shumaID, shumaStatusTypeID, shumaStatusTypeName} = useOldInspectionDetailsContext();

  const getInitialValues = () => {
    formik.setFieldValue('status', {label: shumaStatusTypeName, value: shumaStatusTypeID})
  };

  useEffect(() => {
    getInitialValues();
  }, [shumaStatusTypeID]);

  const formik = useFormik({
    initialValues: {status: {label: '', value: 0}},
    onSubmit: () => {
    },
  });

  const onChangeStatus = (option: any) => {
    formik.setFieldValue('status', {label: option.label, value: option.value});
  };

  const onSubmit = async () => {
    await updateShumaStatus(shumaID, formik.values.status.value);
  }

  const value = {
    status: formik.values.status,
    onChangeStatus,
    onSubmit
  };

  return (
    <OldInspectionStatusContext.Provider value={value}>
      <FormikProvider value={formik}>
        {children}
      </FormikProvider>
    </OldInspectionStatusContext.Provider>
  );
}

OldInspectionStatusProvider.propTypes = {
  children: PropTypes.node,
};
